/* eslint-disable jira/filename-case */
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
export default class Deferred<T> extends Promise<T> {
	// go/jfe-eslint
	static resolve<U>(v: U): Deferred<U> {
		const instance = new Deferred<U>();
		instance.resolve(v);
		return instance;
	}

	// go/jfe-eslint
	static reject<U>(e: Error): Deferred<U> {
		const instance = new Deferred<U>();
		instance.reject(e);
		return instance;
	}

	constructor() {
		// Promise.prototype.then() must be able to call new Deferred(fn)
		// @see https://stackoverflow.com/a/48159603
		// by using arguments flow will ensure we cannot instantiate with constructor parameters
		// eslint-disable-next-line prefer-rest-params
		const [fn] = Array.prototype.slice.call(arguments);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		const callbacks: Array<any> = [];
		super(fn ?? callbacks.push.bind(callbacks));
		this.#resolve = callbacks[0];
		this.#reject = callbacks[1];
	}

	#resolve: undefined | ((arg1: T) => void);

	#reject: undefined | ((arg1: Error) => void);

	resolve(v: T): void {
		this.#resolve?.(v);
	}

	reject(e: Error): void {
		this.#reject?.(e);
	}
}
